import type { SxProps, Theme } from '@mui/material';

export const exportHintSx: SxProps<Theme> = {
  px: 3,
  pt: 1.5,
};
